import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsType = {
  memberId: string | string[]
}

// 取得User Profile (無需驗證)
class FetchUserProfileApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_USER_PROFILE'

    this.config = {
      url: `/v1/user/profile/${params.memberId}`,
      method: 'GET',
    }
  }
}

export const fetchUserProfile = (params: ParamsType) => getCallApiFunction(new FetchUserProfileApi(params))
